import React, { useEffect, useState } from "react";
import { API } from "../../App";
import MasterAdminNavigation from "./navigation";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Car, MapPin, Users } from "lucide-react";

const MasterAdminDashboard = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({ organizations: [] });

    useEffect(() => {
        const token = localStorage.getItem("token");
        fetch(`${API}/master/dashboard`, {
            headers: {
                Authorization: token ? `Bearer ${token}` : "",
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                if (!res.ok) throw new Error("Failed to load master dashboard");
                return res.json();
            })
            .then((json) => setData(json))
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="p-6">Loading master dashboard…</div>;

    return (
       <div className="min-h-screen bg-gray-100"> 
       <MasterAdminNavigation />
        <div className="pt-32 pb-12 px-6 max-w-7xl mx-auto">
             <div className="mb-12 fade-in">
          <h1 className="text-4xl lg:text-5xl font-bold text-[#1A3C34] mb-4">
            Master Admin Dashboard
          </h1>
          <p className="text-xl text-gray-600">Monitor and manage your parking system.</p>
        </div>
        <div className="bento-grid mb-12">
          <Card className="p-8 bg-gradient-to-br from-[#1A3C34] to-[#2D5F52] text-white border-none col-span-1 md:col-span-2 row-span-2">
            <div className="h-full flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-bold mb-4">Total Organizations</h3>
                <div className="space-y-4">
                  <div>
                    <div className="flex justify-between mb-2">
                      <span className="text-sm opacity-90">All Organizations</span>
                      <span className="text-sm opacity-90">
                        {data.organizations.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>

          <Card className="p-8 bg-[#F5F2EB] border-none">
            <Users className="mb-4 text-[#1A3C34]" size={32} />
            <p className="text-sm text-gray-600 mb-2">Total Users</p>
            <p className="text-4xl font-bold text-[#1A3C34]">{data.total_users}</p>
          </Card>

          <Card className="p-8 bg-white border border-gray-100">
            <Car className="mb-4 text-[#1A3C34]" size={32} />
            <p className="text-sm text-gray-600 mb-2">Total Vehicles</p>
            <p className="text-4xl font-bold text-[#1A3C34]">{data.total_vehicles}</p>
          </Card>

          <Card className="p-8 bg-[#FF6B35] text-white border-none">
            <MapPin className="mb-4" size={32} />
            <p className="text-sm opacity-90 mb-2">Available Slots</p>
            <p className="text-4xl font-bold">{data.available_slots}</p>
          </Card>

          <Card className="p-8 bg-white border border-gray-100">
            <Calendar className="mb-4 text-[#1A3C34]" size={32} />
            <p className="text-sm text-gray-600 mb-2">Pending Carpool</p>
            <p className="text-4xl font-bold text-[#1A3C34]">{data.pending_carpool_requests}</p>
          </Card>
        </div>
        </div>
        </div>
    );
};

export default MasterAdminDashboard;